
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_chat",
      function () {
        return require("private-next-pages/blockquiry_chat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blockquiry_chat"])
      });
    }
  